import App from './App.vue'
import Vue from 'vue'

import VueAxios from 'vue-axios'
import Tooltip from 'vue-directive-tooltip'

import axios from './plugins/axios'
import managerLocalStorage from './plugins/managerLocalStorage';
import filters from './plugins/filters'

import parse from './plugins/parse'
import permissions from '@/plugins/permissions'
import ptBr from '@/locales/ptBr.json'

import router from './plugins/router'
import store from './stores/store'
import utils from './plugins/utils'

import utilUri from './plugins/utilUri'
import notify from '@/plugins/notify'

import translate from '@/plugins/translate'
import recaptcha from './plugins/recaptcha'
import dragScroll from './directives/dragScroll'
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'

Vue.use(Tooltip);
Vue.directive('drag-scroll', dragScroll)

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(managerLocalStorage, { store })
Vue.use(utilUri)

Vue.use(filters)
Vue.use(parse)
Vue.use(utils)
Vue.use(notify, { store })

Vue.use(translate, {
  defaultLocale: 'ptBr',
  translates: {
    ptBr
  }
})

Vue.use(permissions, { store })
Vue.use(recaptcha)

Vue.prototype.$name = function () { return this.$options.name }

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
